import { apiClient, getOccmConfigForAgent, occmClient } from "../../utils/clients";
import externals from "utils/externals";
import { getLocalizedValue as t } from "../../i18n";
import { connectorsettings as i18nNamespace } from "../../i18n/namespace";
import { extractErrorMessage } from "@netapp/bxp-design-system-react";
import { LEARN_MORE_LINK_AGENT_VALIDATION } from "modules/add-agent/pdf-utils/pdfConstants";
import _ from "lodash";

export async function fetchAgentValidation(dispatch, agentId, accountId) {
  try {
    const isSaaSUI = process.env.REACT_APP_IS_SAAS === 'true';
    const api = isSaaSUI ? apiClient.get(`${externals.consoleAgentsBackend}/${agentId}/configuration`)
      : occmClient.get(`/account/${accountId}/providers/service-manager/v1/agent/configuration`, getOccmConfigForAgent(agentId));
    const response = await api;
    return response;
  } catch (e) {
    if (e?.response && e?.response?.status == 404) {
      return e.response
    }

    let moreInfo;
    if (e) {
      console.error(e);
      const data = e?.response?.data;
      if (_.isObject(data)) {
        if (!data.message && (data.title || data.detail)) {
          data.message = (data.title ? data.title + ': ' : '') + data.detail
        }
      }

      moreInfo = extractErrorMessage(e);
    }

    dispatch({
      type: "NOTIFICATIONS:ERROR-WITH-LEARN-MORE-LINK",
      payload: {
        message: t("failed_to_get_agent_validation_status", i18nNamespace),
        moreInfo: moreInfo,
        hyperLink: LEARN_MORE_LINK_AGENT_VALIDATION,
        linkText: t("documentation_link_text", i18nNamespace),
        group: 'CONNECTOR-SETTINGS'
      }
    })
  }
}